(function () {
  'use strict';

  /* @ngdoc object
   * @name dashboard.memberships
   * @description
   *
   */
  angular
    .module('dashboard.memberships', [
      'ui.router'
    ]);
}());
